/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Ref, Ref$inboundSchema } from "./ref.js";

/**
 * Configuration needed for time of day defrost scheduler
 */
export type DefrostScheduleConfig = {
  /**
   * A reference to a reading or setting.
   */
  defrostModeRef?: Ref | undefined;
  /**
   * A reference to a reading or setting.
   */
  defrostScheduleRef?: Ref | undefined;
};

/** @internal */
export const DefrostScheduleConfig$inboundSchema: z.ZodType<
  DefrostScheduleConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  defrost_mode_ref: types.optional(Ref$inboundSchema),
  defrost_schedule_ref: types.optional(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "defrost_mode_ref": "defrostModeRef",
    "defrost_schedule_ref": "defrostScheduleRef",
  });
});

export function defrostScheduleConfigFromJSON(
  jsonString: string,
): SafeParseResult<DefrostScheduleConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DefrostScheduleConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DefrostScheduleConfig' from JSON`,
  );
}
